import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  Legend,
  Tooltip,
  BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  Legend,
  Tooltip,
  BarController
);

function secondsToHMS(seconds) {
  seconds = Math.round(seconds);

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
}

export default function CallTrackingChart({ chartData }) {
  const [data, setData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    if (!chartData) return;

    const labels = chartData.userSummary.map((u) => u.userName);
    const attemptedCalls = chartData.userSummary.map((u) => u.attemptedCount);
    const duration = chartData.userSummary.map((u) => u.totalDuration);

    setData({
      labels: labels,
      datasets: [
        {
          type: "line",
          label: "Attempted Calls",
          data: attemptedCalls,
          backgroundColor: "rgba(54, 162, 235, 0.7)",
          tension: 0.3,
          pointRadius: 4,        // increase dot size
          pointHoverRadius: 6,   // bigger on hover
          pointBackgroundColor: "rgba(54, 162, 235, 1)",
        },
        {
          type: "bar",
          label: "Call Duration",
          data: duration,
          backgroundColor: "rgba(255, 159, 64, 0.7)",
          categoryPercentage: 0.4,
          barPercentage: 0.5,
          maxBarThickness: 40
        },
      ],
    });
  }, [chartData]);

  const options = {
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            if (context.dataset.label === "Call Duration") {
                const seconds =
                chartData.userSummary[context.dataIndex].totalDurationSec;
      
              return `${context.dataset.label}: ${secondsToHMS(seconds)}`;
            }
            return `${context.dataset.label}: ${context.raw}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return <Chart type="bar" data={data} options={options} />;
}
